import { useNavigate } from "react-router";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../../../../../../shared/components/card/Card";
import { Button } from "../../../../../../../shared/components/button/Button";
import BreadcrumbPanel from "../../../../../../../shared/components/breadcrumb/BreadcrumbPanel";
import {
  SECURITY_CENTRE_PERMISSIONS_CC_ACCESSLEVEL,
  SECURITY_CENTRE_PERMISSIONS_CC_SECTIONS,
} from "../../../../../../../shared/lib/routesResolver";

const ControlCentrePermissionsOverview = () => {
  const navigate = useNavigate();
  const breadcrumbItems = [{ title: "Permisos Control Centre" }];

  const HomeCard = ({ title, content, link }) => (
    <Card className="w-full md:w-1/4">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>{content}</CardContent>
      <CardFooter>
        <Button className="w-full" onClick={() => navigate(link)}>
          Ir al menú
        </Button>
      </CardFooter>
    </Card>
  );

  return (
    <>
      <div className="px-4 pb-4 sm:px-6">
        <BreadcrumbPanel items={breadcrumbItems} />
      </div>
      <div className="flex flex-col gap-y-10">
        <div className="text-3xl text-center font-normal md:leading-4 p-4">
          Gestión de permisos en AdQuiver Control Centre
        </div>
        <div className="p-4 flex flex-col md:flex-row justify-between gap-y-4 md:gap-x-4">
          <div></div>
          <HomeCard
            title="Secciones"
            content="Menú de administración de permisos para gestionar qué secciones se pueden visualizar en Control Centre."
            link={SECURITY_CENTRE_PERMISSIONS_CC_SECTIONS}
          />
          <HomeCard
            title="Access level"
            content="Menú de administración de los permisos de visualización de las páginas."
            link={SECURITY_CENTRE_PERMISSIONS_CC_ACCESSLEVEL}
          />
          <div></div>
        </div>
      </div>
    </>
  );
};

export default ControlCentrePermissionsOverview;
